import { OpenStreetMapProvider } from 'leaflet-geosearch';
import regeneratorRuntime from "regenerator-runtime";

const spinner = '<div class="load-spin"><div></div><div></div><div></div><div></div></div>';

function calculateDistance(origin, destination) {
    const earthRadius = 6371;
    const toRadians = (angle) => angle * (Math.PI / 180);
    const dLat = toRadians(destination.lat - origin.lat);
    const dLon = toRadians(destination.lng - origin.lng);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRadians(origin.lat)) * Math.cos(toRadians(destination.lat)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return earthRadius * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

class PickProductStoreModal {
    constructor() {
        this.init();
    }

    /**
     * Main method. Used for setting up other methods
     *
     */
    init() {
        let $ = jQuery;
        let self = this;

        $(document).ready(function () {
            $('.mm__pick-store-modal.product-modal').delegate('.store-card', 'click', function () {
                if($(!this).hasClass('is-active')) {
                    $(this).addClass('is-active')
                } else {
                    $(this).removeClass('is-active')
                }
                $(this).children('.btn-wrapper').slideToggle(300);
            });

            $('.mm__pick-store-modal.product-modal .close-to-you').click(function () {
                self.searchByPosition(self);
            });

            // Stop form submit and trigger text search
            $('.mm__pick-store-modal.product-modal #pick-store').submit(function (e) {
                e.preventDefault();
                jQuery('.error-no-shop').remove();
                const query = $('#pick-product-store-input').val();
                if (query) {
                    self.bindSearchInput(query);
                }
            });
        });
    }

    /**
     * Responsible for handling positional coordinates
     *
     * @param {this} self
     */
    searchByPosition(self) {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                const POS = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };
                self.showResult(self, POS);
            }, function () {
                alert("Error: The Geolocation service failed.");
            });
        } else {
            alert("Error: Your browser doesn't support geolocation.");
        }
    }

    bindSearchInput(input) {
        const self = this;
        self.geoCodeSearch(input);
    }

    async geoCodeSearch(searchTerm) {
        let $ = jQuery;

        // Add spinner
        $('.mm__pick-store-modal.product-modal .search-store').find('.pre-input').children().css('visibility', 'hidden');
        $('.mm__pick-store-modal.product-modal .search-store').find('.pre-input').append(spinner);

        const provider = new OpenStreetMapProvider({
            params: { countrycodes: 'se' },
        });

        const results = await provider.search({ query: searchTerm });

        setTimeout(() => {
            // Remove spinner
            $('.mm__pick-store-modal.product-modal .search-store').find('.pre-input').children('.load-spin').remove();
            $('.mm__pick-store-modal.product-modal .search-store').find('.pre-input').children().css('visibility', 'visible');

            if (results.length > 0) {
                const pos = { lat: results[0].y, lng: results[0].x };
                this.showResult(this, pos, searchTerm);
            } else {
                $('.mm__pick-store-modal.product-modal .search-store').after(
                    '<span class="error-no-shop">Adressen kunde ej hittas</span>'
                );
            }
        }, 1000);
    }

    /**
     * Responsible for displaying results based on either search coordinates or positional coordinates
     *
     * @param {this} self
     * @param {object} origin
     */
    showResult(self, origin, searchTerm = '') {
        let $ = jQuery;

        const userTown = searchTerm.split(',')[0].toLowerCase().trim();
        let foundTown = null;

        $('.mm__pick-store-modal.product-modal .store-card').each(function (i, el) {
            if ($(this).hasClass('is-hidden')) {
                $(this).removeClass('is-hidden');
            }

            let destination = { lat: parseFloat($(this).data('lat')), lng: parseFloat($(this).data('lng')) };
            const distance = calculateDistance(origin, destination);

            if (distance > 100) {
                $(this).addClass('is-hidden');
            }

            if (userTown && $(this).data('town') === userTown) {
                foundTown = $(this);
            }
        });

        setTimeout(() => {
            let totalStoreNumber = $('.mm__pick-store-modal.product-modal .store-card').length;
            let filteredStoreNumber = $('.mm__pick-store-modal.product-modal .store-card:not(.is-hidden)').length;
            $('.mm__pick-store-modal.product-modal .number-of-stores').empty();
            $('.mm__pick-store-modal.product-modal .number-of-stores').text(`${filteredStoreNumber} av ${totalStoreNumber} butiker`);

            if ($('.mm__pick-store-modal.product-modal .stores-wrapper').length) {
                var $wrapper = $('.mm__pick-store-modal.product-modal .stores-wrapper');
                $wrapper.find('.store-card:not(.is-hidden)').sort(function (a, b) {
                    return calculateDistance(origin, { lat: parseFloat(a.dataset.lat), lng: parseFloat(a.dataset.lng) })
                         - calculateDistance(origin, { lat: parseFloat(b.dataset.lat), lng: parseFloat(b.dataset.lng) });
                }).appendTo($wrapper);

                if (foundTown) {
                    $wrapper.prepend(foundTown);
                }
            }
        }, 1000);
    }
}

export default PickProductStoreModal;
